import { render } from "./OffertaContextMenu.vue?vue&type=template&id=043d3a72&ts=true"
import script from "./OffertaContextMenu.vue?vue&type=script&lang=ts"
export * from "./OffertaContextMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__